module.exports = __webpack_public_path__ + "6cad141a23f10be3061f6eb8571af68c.svg";